import BaseBarSeries from "./private/BaseBarSeries.js";
import Bars from "./private/Bars.js";
import { jsx as _jsx } from "react/jsx-runtime";
function BarSeries(_ref) {
  let {
    colorAccessor,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(BaseBarSeries, {
    ...props,
    colorAccessor: colorAccessor,
    BarsComponent: Bars
  });
}
export default BarSeries;